export const INITIAL_NOTIFICATIONS_RECEIVED = "INITIAL_NOTIFICATIONS_RECEIVED";
export const NOTIFICATION_BATCH_RECEIVED = "NOTIFICATION_BATCH_RECEIVED";
export const ACTIVE_NOTIFICATIONS_PAGE_REQUESTED = "ACTIVE_NOTIFICATIONS_PAGE_REQUESTED";
export const ACTIVE_NOTIFICATIONS_PAGE_RECEIVED = "ACTIVE_NOTIFICATIONS_PAGE_RECEIVED";
export const ACTIVE_NOTIFICATIONS_PAGE_FAILED = "ACTIVE_NOTIFICATIONS_PAGE_FAILED";
export const SET_ACTIVE_NOTIFICATIONS_QUERY = "SET_ACTIVE_NOTIFICATIONS_QUERY";
